/**
 * Definisi kolom tabel Inventaris & Aset (user request 2026-10-22).
 *
 * Satu sumber kebenaran untuk:
 * - daftar kolom yang bisa di-show/hide (ASSET_COLUMN_DEFS),
 * - default bawaan (ASSET_DEFAULT_COLUMNS),
 * - getter nilai sel per kolom (assetCellValue).
 *
 * Kolom fixed (tidak bisa disembunyikan): checkbox, No. Asset, Nama, Aksi.
 * Default global diatur admin via Pengaturan → Tampilan Aset
 * (GET/PUT /settings/asset-columns). Override per user via
 * /user-prefs/table/assets.
 */
import { fmtDate } from "@/lib/constants";

export const ASSET_COLUMN_DEFS = [
  { key: "category", label: "Kategori" },
  { key: "brand", label: "Brand" },
  { key: "location", label: "Lokasi" },
  { key: "pic", label: "PIC" },
  { key: "status", label: "Status" },
  { key: "plate_number", label: "No. Kendaraan (Plat)" },
  { key: "vin", label: "No. Rangka (VIN)" },
  { key: "engine_number", label: "No. Mesin" },
  { key: "tax_due_date", label: "Tempo Pajak Kendaraan" },
  { key: "stnk_expiry_date", label: "STNK Berlaku s.d." },
  { key: "model_serial", label: "Model/Serial Mesin" },
  { key: "capacity_spec", label: "Kapasitas/Spesifikasi" },
  { key: "purchase_date", label: "Tanggal Pembelian" },
  { key: "custom_notes", label: "Catatan" },
  { key: "updated_at", label: "Terakhir Diubah" },
];

export const ASSET_DEFAULT_COLUMNS = ["category", "brand", "location", "pic", "status"];

export const ASSET_COL_LABEL = Object.fromEntries(ASSET_COLUMN_DEFS.map((d) => [d.key, d.label]));

/** Nilai tampilan sel untuk kolom opsional. Return null → render "—". */
export function assetCellValue(a, ck) {
  const v = a?.vehicle || {};
  const m = a?.machine || {};
  switch (ck) {
    case "brand": return a?.brand || null;
    case "location": return a?.location_name || null;
    case "pic": return a?.pic_name || null;
    case "plate_number": return v.plate_number || null;
    case "vin": return v.vin || null;
    case "engine_number": return v.engine_number || null;
    case "tax_due_date": return v.tax_due_date ? fmtDate(v.tax_due_date) : null;
    case "stnk_expiry_date": return v.stnk_expiry_date ? fmtDate(v.stnk_expiry_date) : null;
    case "model_serial": return m.model_serial || null;
    case "capacity_spec": return m.capacity_spec || null;
    case "purchase_date": return a?.purchase_date ? fmtDate(a.purchase_date) : null;
    case "custom_notes": return a?.custom_notes || null;
    case "updated_at": return a?.updated_at ? fmtDate(a.updated_at) : null;
    default: return null;
  }
}
